(function(){
  var isMobile = window.matchMedia('(max-width: 768px)').matches;
  document.querySelectorAll('.dv2-col li[data-img]').forEach(function(li){
    var popup = li.querySelector('.dv2-popup');
    if(!popup) return;
    if (isMobile) {
      // Tap to toggle on mobile
      li.addEventListener('click', function(e){
        var wasOpen = li.classList.contains('dv2-tapped');
        // Close all others
        document.querySelectorAll('.dv2-tapped').forEach(function(el){ el.classList.remove('dv2-tapped'); });
        if (!wasOpen) li.classList.add('dv2-tapped');
      });
    } else {
      // Hover positioning on desktop
      li.addEventListener('mouseenter', function(e){
        var rect = li.getBoundingClientRect();
        var pw = 420;
        var left = rect.left + (rect.width / 2) - (pw / 2);
        if (left < 16) left = 16;
        if (left + pw > window.innerWidth - 16) left = window.innerWidth - pw - 16;
        popup.style.left = left + 'px';
        var top = rect.top - 290;
        if (top < 70) top = rect.bottom + 12;
        popup.style.top = top + 'px';
        popup.style.bottom = 'auto';
      });
    }
  });
})();